import { computed } from 'mobx'
import localStorage from 'mobx-localstorage'

export const LS_SESSION_TOKEN = 'qborder_auth_token'

export default class Storage {

  storage = localStorage

  @computed
  get authToken() {
    return this.storage.getItem(LS_SESSION_TOKEN)
  }
  set authToken(value) {
    this.storage.setItem(LS_SESSION_TOKEN, value)
  }

}



// WEBPACK FOOTER //
// ./src/services/storage.js